import React, {useState} from 'react'
import {Link} from 'react-router-dom'
import {useDispatch} from 'react-redux'
import {toAbsoluteUrl} from '../../../../../_metronic/helpers'
import {AdminSigninData} from '../../../../Redux/AdminPanel/AdminAuthSlice'
import {useFormik} from 'formik'
import {loginSchema} from '../../../../Utils/_helpers/ValidationSchema'
import clsx from 'clsx'
import {resetRedux} from '../../../../Redux/store'

const AdminLogin = () => {
  const dispatch = useDispatch()
  const [visible, setVisible] = useState(false)
  const [passwordType, setPasswordType] = useState({
    password: true,
  })

  const initialValues = {
    email: '',
    password: '',
  }
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values, {setStatus, setSubmitting}) => {
      setSubmitting(false)
      setLoading(true)
      setTimeout(() => {
        let data = {
          email: values.email,
          password: values.password,
        }
        dispatch(resetRedux())
        dispatch(AdminSigninData(data))
        setLoading(false)
      }, 1000)
    },
  })
  return (
    <>
      {
        <>
          <form className='form w-100' onSubmit={formik.handleSubmit} noValidate>
            {/* begin::Heading */}
            <div className='card-body'>
              <div className='mb-5 text-start'>
                <a href='#' className='mb-4 d-flex flex-center'>
                  <h1 className='text-dark' data-kt-translate='sign-in-title'>
                    Sign In
                  </h1>
                </a>
              </div>

              <div className='fv-row mb-5'>
                <label className='form-label fs-6  text-dark'>Email</label>
                <input
                  placeholder='Email'
                  {...formik.getFieldProps('email')}
                  className={clsx(
                    'form-control form-control-lg form-control-solid',
                    {'is-invalid': formik.touched.email && formik.errors.email},
                    {
                      'is-valid': formik.touched.email && !formik.errors.email,
                    }
                  )}
                  type='email'
                  name='email'
                  autoComplete='off'
                />
                {formik.touched.email && formik.errors.email && (
                  <div className='fv-plugins-message-container'>
                    <span role='alert' className='text-danger'>
                      {formik.errors.email}
                    </span>
                  </div>
                )}
              </div>

              <div className='fv-row mb-7'>
                <div className='d-flex justify-content-between'>
                  <div className='d-flex flex-stack mb-2'>
                    <label className='form-label text-dark fs-6 mb-0'>Password</label>
                    {/* end::Link */}
                  </div>
                </div>
                <div className='password-wrap'>
                  <input
                    type={passwordType.password ? 'password' : 'text'}
                    placeholder='Password'
                    autoComplete='off'
                    {...formik.getFieldProps('password')}
                    className={clsx(
                      'form-control form-control-lg form-control-solid'
                      // {
                      //   'is-invalid': formik.touched.password && formik.errors.password,
                      // },
                      // {
                      //   'is-valid': formik.touched.password && !formik.errors.password,
                      // }
                    )}
                  />
                  <span
                    className='svg-icon svg-icon-3'
                    onClick={() => {
                      setPasswordType({...passwordType, password: !passwordType.password})
                    }}
                  >
                    {passwordType.password ? (
                      <i className='bi bi-eye-fill'></i>
                    ) : (
                      <i className='bi bi-eye-slash-fill'></i>
                    )}
                  </span>
                </div>
                {formik.touched.password && formik.errors.password && (
                  <div className='fv-plugins-message-container'>
                    <div className='fv-help-block'>
                      <span role='alert' className='text-danger'>
                        {formik.errors.password}
                      </span>
                    </div>
                  </div>
                )}
                <div className='forgot-pass'>
                  <Link
                    to='/auth/forgot-password'
                    className='link-primary fs-6 fw-bolder d-block text-end mt-3'
                  >
                    Forgot Password ?
                  </Link>
                </div>
              </div>
              {/* end::Form group */}

              {/* begin::Action */}
              <div className=''>
                <button
                  type='submit'
                  id='kt_sign_in_submit'
                  className='btn  me-2 flex-shrink-0 auth-primary-btn w-100'
                  disabled={formik.isSubmitting || !formik.isValid}
                >
                  {!loading && (
                    <span className='indicator-label text-white' data-kt-translate='sign-in-submit'>
                      Sign In
                    </span>
                  )}
                  {loading && (
                    <span className='indicator-progress' style={{display: 'block'}}>
                      Please wait...
                      <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                    </span>
                  )}
                </button>
              </div>
            </div>

            <div className='auth-bottom-pages'>
              <ul>
                <li>
                  <a target='_blank' href='https://www.cellcast.com/au/legal/terms-of-use'>
                    Terms
                  </a>
                </li>
                <li>
                  <a target='_blank' href='https://www.cellcast.com/au/legal/privacy-policy'>
                    Privacy
                  </a>
                </li>
                <li>
                  <a href={`mailto:info@cellcast.com`}>Contact us</a>
                </li>
              </ul>
            </div>
          </form>
        </>
      }
    </>
  )
}

export default React.memo(AdminLogin)
